const hours = [
  { day: 'Monday', time: '10:00am – 7:30pm' },
  { day: 'Tuesday', time: '10:00am – 7:00pm' },
  { day: 'Wednesday', time: '10:00am – 7:30pm' },
  { day: 'Thursday', time: '10:00am – 7:30pm' },
  { day: 'Friday', time: '10:00am – 7:30pm' },
  { day: 'Saturday', time: '10:00am – 5:00pm' },
  { day: 'Sunday', time: '10:00am – 4:00pm' },
];

export default function Hours() {
  const today = new Date().getDay();
  const dayIndex = today === 0 ? 6 : today - 1;

  const handleBooking = () => {
    if (typeof window !== 'undefined' && (window as any).__openBookingModal) {
      (window as any).__openBookingModal('No Preference');
    }
  };

  return (
    <section id="hours" className="py-24 bg-amber-50">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="text-red-600 text-xs tracking-widest font-semibold mb-4 whitespace-nowrap">HOURS</div>
          <h2 className="text-5xl md:text-6xl font-bold text-black mb-6">When We&apos;re Open</h2>
        </div>

        {/* Hours Table */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <div className="space-y-4">
            {hours.map((item, index) => (
              <div 
                key={index}
                className={`flex justify-between items-center py-4 border-b border-gray-100 last:border-0 ${index === dayIndex ? 'bg-red-50 -mx-4 px-4 rounded-lg' : ''}`}
              >
                <span className={`text-xl font-bold ${index === dayIndex ? 'text-red-600' : 'text-black'}`}>
                  {item.day}
                </span>
                <span className={`text-xl ${index === dayIndex ? 'text-red-600 font-semibold' : 'text-gray-600'}`}>
                  {item.time}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Additional Info */}
        <div className="text-center">
          <div className="bg-white rounded-2xl p-6 mb-6 text-left max-w-xl mx-auto">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-walk-line text-red-600 text-xl"></i>
              </div>
              <div>
                <p className="font-bold text-gray-900 text-base mb-1">Walk-Ins Welcome</p>
                <p className="text-gray-600 text-sm leading-relaxed">
                  We accept walk-ins during opening hours, however availability depends on how busy the shop is. Closer to closing time (around 6:00pm–7:00pm), if there are already several customers waiting, we may not be able to accept additional walk-ins due to time constraints.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 pt-4 border-t border-gray-100">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-global-line text-red-600 text-xl"></i>
              </div>
              <div>
                <p className="font-bold text-gray-900 text-base mb-1">Online Booking — 24/7</p>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Book your appointment online any time of day or night — no need to call during business hours.
                </p>
              </div>
            </div>
          </div>
          <button 
            onClick={handleBooking}
            className="bg-red-600 text-white px-8 py-4 rounded-lg text-base font-bold hover:bg-red-700 transition-all hover:shadow-xl whitespace-nowrap"
          >
            BOOK YOUR TIME SLOT
          </button>
        </div>
      </div>
    </section>
  );
}